<template>
  <div class="input-select">
    <select
      class="input-select__input"
      :name="name"
      :value="value"
      @change="changeHandler"
    >
      <option
        v-for="option in options"
        :key="option.id"
        :value="option.value"
      >{{ option.name }}</option>
    </select>

    <v-icon class="input-select__icon">mdi-chevron-down</v-icon>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: null,
    },
  },
  emits: ['change'],
  setup(props, context) {
    const changeHandler = function (e) {
      context.emit('change', {
        type: props.name,
        value: e.target.value,
      });
    };

    return {
      changeHandler,
    };
  },
};
</script>

<style lang="scss">
.input-select {
  $this: 'input-select';
  position: relative;

  &__input {
    width: 100%;
    border: 1px solid $color-periwinkle;
    border-radius: 4px;
    outline: none;
    padding: 5px 10px;
    font-size: 14px;

    // &:focus {
    //   & + .#{$this}__icon {
    //     transform: rotate(180deg);
    //   }
    // }
  }

  &__icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
    font-size: 16px;
    color: $color-periwinkle;
    transition: transform $anim-base;
  }
}
</style>
